export const hideAllTooltips = () => {
  try {
    document.querySelectorAll('.tooltip:popover-open').forEach(el => {
      (el as HTMLElement).hidePopover();
    });
  } catch {
    // :popover-open selector not supported (e.g. JSDOM) – nothing to hide
  }
};
